import { render } from "./TicketData.vue?vue&type=template&id=0d36633f&scoped=true&ts=true"
import script from "./TicketData.ts?vue&type=script&lang=ts"
export * from "./TicketData.ts?vue&type=script&lang=ts"

import "./TicketData.vue?vue&type=style&index=0&id=0d36633f&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d36633f"]])

export default __exports__